## Inventario y Documentos de Aprobaciones

Esta actualización incorpora dos módulos nuevos a la plataforma: uno para gestionar la disponibilidad de propiedades y otro para coordinar la revisión y aprobación de documentos dentro de tus negociaciones.

---

## 📦 Inventario

![Inventario](https://assets.elevenestudio.me/915D3B02-IDC-FORMS-INVENTORY.png)

Ahora puedes ver en un solo lugar el estado actual de todas las propiedades: cuáles están disponibles, reservadas, en negociación o vendidas. Desde el inventario puedes hacer reservas, gestionarlas y seguir todo el historial de cada propiedad.

### ¿Qué puedes hacer?
- Ver el estado de disponibilidad de todas las propiedades en tiempo real
- Reservar una propiedad seleccionando fechas dentro de una ventana de 15 días
- Liberar o rechazar reservas con notas
- Consultar el historial completo de cada propiedad: quién la reservó, cuándo y qué sucedió
- Iniciar una negociación directamente desde una propiedad que ya tienes reservada
- Ver métricas generales: disponibles, reservadas, en negociación, pendientes de autorización y vendidas

> Algunas propiedades requieren una autorización adicional antes de confirmar la reserva. En esos casos, el sistema notifica automáticamente al responsable para que apruebe.

---

## 📄 Documentos de Aprobaciones

![Documentos de Aprobaciones](https://assets.elevenestudio.me/620C5966-IDC-FORMS-APPROVALS-DOCUMENTS.png)

Dentro de cada negociación ahora puedes crear flujos de aprobación para tus documentos. Eliges quiénes participan, cada uno recibe un enlace para revisar el documento y responder, y tú sigues el estado de todo el proceso desde un solo panel.

### ¿Qué puedes hacer?
- Generar un documento PDF combinando los documentos de la negociación
- Armar un flujo de aprobación con los participantes que necesitas (propietario, gerente, asesor u otros)
- Definir quiénes deben aprobar de forma obligatoria y quiénes de forma opcional
- Ver en tiempo real quién ya revisó el documento, quién aprobó y quién rechazó
- Aprobar, rechazar o cancelar el flujo con una razón
- Agregar comentarios para coordinar con el equipo
- Los participantes externos reciben un enlace por email y pueden revisar y responder sin necesidad de tener una cuenta en la plataforma

## 🔧 Mejoras

- Ajustes de navegación y permisos en el flujo de inventario y reservas
